import { render, staticRenderFns } from "./MarginalityByProductDetailReport.vue?vue&type=template&id=8d4a5862&scoped=true&"
import script from "./MarginalityByProductDetailReport.vue?vue&type=script&lang=ts&"
export * from "./MarginalityByProductDetailReport.vue?vue&type=script&lang=ts&"
import style0 from "./MarginalityByProductDetailReport.vue?vue&type=style&index=0&id=8d4a5862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4a5862",
  null
  
)

export default component.exports